import { useState } from 'react';
import { GlobalSearch } from './GlobalSearch';
import { NavLink, Outlet } from 'react-router';
import { useAuth } from '../auth';
import { cn } from '../ui';

type Role = 'owner' | 'staff' | 'picker';

type NavigationGroup = {
  label: string;
  links: { to: string; label: string; end?: boolean; roles: Role[] }[];
};

/**
 * Group work by the question a person is trying to answer, following the familiar NetSuite pattern. Routes stay
 * exactly as they were; the labels only make the increasingly large sidebar easier to scan.
 */
const groups: NavigationGroup[] = [
  {
    label: 'Overview',
    links: [{ to: '/', label: 'Dashboard', end: true, roles: ['owner', 'staff'] }],
  },
  {
    label: 'Inventory',
    links: [
      { to: '/items', label: 'Items', roles: ['owner', 'staff', 'picker'] },
      { to: '/put-away', label: 'Put away', roles: ['owner', 'staff'] },
      { to: '/locations', label: 'Locations', roles: ['owner', 'staff', 'picker'] },
      { to: '/stocktaking', label: 'Stocktaking', roles: ['owner', 'staff'] },
      { to: '/transfers', label: 'Transfers', roles: ['owner', 'staff'] },
      { to: '/buy-list', label: 'Buy list', roles: ['owner', 'staff'] },
      { to: '/deal-radar', label: 'Deal radar', roles: ['owner', 'staff'] },
    ],
  },
  {
    label: 'Transactions',
    links: [
      { to: '/purchases', label: 'Purchases', roles: ['owner', 'staff'] },
      { to: '/purchases?source=partout', label: 'Part-outs', roles: ['owner', 'staff'] },
      { to: '/bills', label: 'Bills', roles: ['owner', 'staff'] },
      { to: '/item-receipts', label: 'Item receipts', roles: ['owner', 'staff'] }, { to: '/inbound-shipments', label: 'Inbound shipments', roles: ['owner', 'staff'] },
      { to: '/sales', label: 'Sales', roles: ['owner', 'staff'] },
    ],
  },
  {
    label: 'Relationships',
    links: [
      { to: '/suppliers', label: 'Vendors', roles: ['owner', 'staff'] },
      { to: '/customers', label: 'Customers', roles: ['owner', 'staff'] },
    ],
  },
  {
    label: 'Commerce',
    links: [
      { to: '/pricing', label: 'Pricing', roles: ['owner', 'staff'] },
      { to: '/price-movers', label: 'Price movers', roles: ['owner', 'staff'] },
      { to: '/sync', label: 'Sync', roles: ['owner', 'staff'] },
    ],
  },
  {
    label: 'Analysis',
    links: [{ to: '/reports', label: 'Reports', roles: ['owner', 'staff'] }],
  },
  {
    label: 'Setup',
    links: [
      { to: '/channels', label: 'Channels', roles: ['owner', 'staff'] },
      { to: '/settings', label: 'Settings', roles: ['owner', 'staff', 'picker'] },
    ],
  },
];

export function Layout() {
  const { user, logout } = useAuth(); const [open, setOpen] = useState<string | null>(null);
  const visible = groups.map((group) => ({ ...group, links: group.links.filter((link) => user && link.roles.includes(user.role)) })).filter((group) => group.links.length);
  return <div className="min-h-full bg-slate-50"><header className="sticky top-0 z-20 border-b border-slate-800 bg-slate-900 text-slate-100"><div className="flex items-center gap-3 px-4"><NavLink to="/" end className="py-3 text-lg font-semibold hover:text-brand">BrickLoop</NavLink><nav className="flex min-w-0 flex-1 overflow-visible">{visible.map((group) => <div key={group.label} className="relative" onMouseEnter={() => setOpen(group.label)} onMouseLeave={() => setOpen(null)}><button type="button" onClick={() => setOpen(open === group.label ? null : group.label)} className="px-3 py-4 text-sm hover:bg-slate-800">{group.label} ▾</button>{open === group.label && <div className="absolute left-0 top-full min-w-44 border border-slate-200 bg-white py-1 text-slate-800 shadow-lg">{group.links.map((link) => <NavLink key={link.to} to={link.to} end={link.end} onClick={() => setOpen(null)} className={({ isActive }) => cn('block px-4 py-2 text-sm hover:bg-slate-100', isActive && 'bg-slate-100 font-semibold')}>{link.label}</NavLink>)}</div>}</div>)}</nav><GlobalSearch /><div className="text-xs"><NavLink to="/m" className="mr-3 hover:text-white">Phone view</NavLink><span className="mr-3">{user?.name}</span><button onClick={() => void logout()} className="hover:text-white">Sign out</button></div></div></header><main className="p-4 md:p-6"><div className="mx-auto max-w-7xl"><Outlet /></div></main></div>;
}
